.fp-vertical-spacing.-s-xs
  .fp-vertical-spacing--line
    MediasInputVue(:medias='medias' :touched='touched' :accept='[MediaType.IMAGE, MediaType.VIDEO]' @updated-medias='updatedMedias => updateMedia(updatedMedias.value)' @unsupported-files='fileCount => onUnsupportedFile(fileCount.value)' multiple)
  .fp-vertical-spacing--line(v-if='unsupportedFileCount > 0' data-test='unsupported-media')
    span.fp-text.-color-danger {{ t('mediaInput.unsupportedMediaMultiple', unsupportedFileCount) }}
